import React from 'react'
import categories from './data';
import { motion } from 'framer-motion';


const Skills = () => {

    const skillvar = {
        initial : {
            y : 100,
            opacity : 0
          },
          animate : {
            opacity : 1,
            y: 0,
            transition : {
              duration: 0.5,
              staggerChildren : 0.15,
              when : "beforeChildren",
            } ,
        }
    }

    const slide = {
        initial : {
            y: 60,
            opacity : 0
          },
          animate : {
            opacity : 1,
            y: 0,
            transition : {
              duration: 0.5,

            } ,
        }
    }


  return (
    <div className='portfolio py-4' id='skills'>
        <div className="container2">
            <div className="sec-header text-center mb-4">
                <h2 className="text-bold">Skills</h2>
                <p className="about-text text-muted">Technical Toolbox</p>
            </div>
            <motion.div variants={skillvar} initial="initial" whileInView="animate" className="flagship-grid m-0" viewport={{ once: true }}>
                {
                    categories.map((category) => (
                        <motion.div variants={slide} key={category.id} className="flagship-card">
                            <h6 className='fw-bold'>{category.title}</h6>
                            <div className="flagship-tags">
                                {category.skills.map((skill) => (
                                    <span className="flagship-tag" key={skill}>{skill}</span>
                                ))}
                            </div>
                        </motion.div>
                    ))
                }
            </motion.div>
        </div>
    </div>
  )
}

export default Skills
